import { inject, injectable } from 'inversify';
import { action, computed, makeObservable } from 'mobx';
import type { IObjectViewModel } from '@/engine/app/interfaces';
import type { ViewsService } from '@/engine/app/Views.service';
import { TYPES } from '@/engine/ioc';

@injectable()
export class ObjectsListController {
  private readonly _viewsService: ViewsService;

  public constructor(@inject(TYPES.ViewsService) viewsService: ViewsService) {
    this._viewsService = viewsService;
    makeObservable(this);
  }

  @computed
  public get objects(): Array<IObjectViewModel> | undefined {
    return this._viewsService.currentView?.getObjects();
  }

  @action
  public toggleObjectVisibility(object: IObjectViewModel): void {
    object.setVisibility(!object.isVisible);
  }
}
